/* istanbul ignore file */
import { SidebarStickyMenu, SummaryMenuItem, ActivitiesMenuItem } from 'framework/ui/menu';
import { useParams } from 'react-router-dom';
import { useLeadUrl } from 'domain/shared/lead';
import { useAuthorization } from 'framework/authorization';
import { READ_TIMELINE } from 'domain/sales/salesService';

const ShowLeadPageMenu = () => {
  const { id } = useParams<Dictionary<string>>();
  const { getSingleEntityUrl, getTimelineUrl } = useLeadUrl();
  const { isGranted } = useAuthorization();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
      <ActivitiesMenuItem linkUrl={getTimelineUrl(id)} isVisible={isGranted(READ_TIMELINE)} />
    </SidebarStickyMenu>
  );
};

export default ShowLeadPageMenu;
